<script>
  import { cardState, width, height } from "./stores";
  export let text = `Кожаная сумка с прорезиненным ремнем. 
          Цвет: черный
          Размер: one size
          Возможно кастомизировать.`;
  export let url =
    "https://cdn.glitch.global/a497fb41-e769-4d8b-a53b-7e2689ae4f9b/GF_01_NEW_small.jpg?v=1659688163896";
  export let action = "";

  let imageWidth;
  let imageHeight;
  let containerWidth;
  let containerHeight;
  let positionRight;
  let positionTop;
  if ($width > 700) {
    imageWidth = 575;
    imageHeight = 435;
    containerWidth = 595;
    containerHeight = 795;
    positionRight = ($width - containerWidth) / 2;
    positionTop = ($height - containerHeight) / 2;
  } else {
    imageWidth = 280;
    imageHeight = 210;
    containerWidth = 300;
    containerHeight = 500;
    positionRight = ($width - containerWidth) / 2;
    positionTop = ($height - containerHeight) / 2;
  }

  function changeCardState() {
    cardState.set(false);
  }
</script>

<div class="сontainer" style="top: {positionTop}px; right: {positionRight}px; width: {containerWidth}px; height: {containerHeight}px;">
<div class="textContainer">
<button class="quitButton" style="margin-top: 20px" on:click={changeCardState}>X</button>
<br>
<div class="image" style="width: {imageWidth}px; height: {imageHeight}px;">
<img src={url} alt="happy numbers" width="{imageWidth}px" height="{imageHeight}px">
</div>
<h3>Кожаная сумка с прорезиненным ремнем.</h3>
  <p>Цвет: черный<br>
  Размер: one size<br>
  Возможно кастомизировать.</p>
<button class="button" style="margin-top: 20px; width: {imageWidth}px;" on:click={action}><h3>На сайт</h3></button>

</div>
</div>

<style>
  .сontainer {
    position: absolute;
    top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    z-index: 10;
    backdrop-filter: blur(80px);
    -webkit-backdrop-filter: blur(80px);
    border: 1px solid rgba(42, 42, 54, 1);
    padding: 20px;
    font-size: 16px;
  }
  .textContainer {
    /* width: 300px; */
    /* margin: 20px; */
    width: 100%;
    height: 100%;
    text-align: left;
    font-size: 16px;
    /* backdrop-filter: blur(80px); */
  }
  .button {
    width: 100%;
    height: 60px;
    margin-top: 20px;
    background: black;
    border: 1px solid black;
    color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 5px 5px 0 #c4e1ff;
    cursor: pointer;
  }
  .button:hover:enabled {
    background: rgba(255, 255, 255, 0.5);
    color: black;
  }

  .quitButton {
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
    background: none;
    border: 1px solid rgba(42, 42, 54, 1);
    cursor: pointer;
    font-size: 16px;
  }
  .quitButton:hover {
    background: black;
    color: white;
  }

  .image {
    background: grey;
    box-shadow: 5px 5px 0 #c4e1ff;
  }
</style>